import { render, staticRenderFns } from "./Newoptions.vue?vue&type=template&id=17867466"
import script from "./Newoptions.vue?vue&type=script&lang=js"
export * from "./Newoptions.vue?vue&type=script&lang=js"
import style0 from "./Newoptions.vue?vue&type=style&index=0&id=17867466&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports